export default {"src":"/_next/static/media/weebly.c35429e1.svg","height":140,"width":182,"blurWidth":0,"blurHeight":0};